export default "__VITE_ASSET__FLB2pJGq__"